import { IS_OPEN_MODAL } from 'core/store/global'
import React from 'react'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'
import KbpayContentImage from 'assets/img/kbpay_content.svg'
import { getExecutorForPartner } from 'core/util/partner'
import { getPartnerId } from 'core/singleton'
import KbpayAPI from 'core/axios/kbpayApi/kbpay.api'

const KBPayLiveCancelModal: React.FC = () => {
  const [, setIsOpenModalData] = useRecoilState(IS_OPEN_MODAL)

  const partnerId = getPartnerId()

  const handleClickCancellation = async () => {
    const res = await KbpayAPI.cancelLiveShopping()

    if (!res) return
    getExecutorForPartner(partnerId)?.reqMoveMainPageBridge?.()
  }

  const handleClickCancel = () => setIsOpenModalData(null)

  return (
    <StyledModal>
      <StyledContent>
        <StyledContentImageWrapper>
          <StyledContentImage src={KbpayContentImage} alt={'이미지'} /> {/** TODO src 설정 */}
        </StyledContentImageWrapper>
        <StyledContentDescription>
          {'KB Pay live 쇼핑 이용을 해지 하시겠습니까?'}
        </StyledContentDescription>
      </StyledContent>
      <StyledFooter>
        <StyledButtonContainer>
          <StyledCancellationButton onClick={handleClickCancellation}>
            {'해지하기'}
          </StyledCancellationButton>
          <StyledCancelButton onClick={handleClickCancel}>{'취소'}</StyledCancelButton>
        </StyledButtonContainer>
      </StyledFooter>
    </StyledModal>
  )
}

const StyledModal = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 156px;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 20;
`
const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  height: calc(100% - 76px);
`
const StyledContentImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`
const StyledContentImage = styled.img`
  position: absolute;
  bottom: 0;
  width: calc(100% - 94px * 2);
  height: 168px;
`
const StyledContentDescription = styled.span`
  font-size: 14px;
  color: #666666;
  text-align: center;
`
const StyledFooter = styled.div`
  width: 100%;
  height: 76px;
`
const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
`
const StyledCancellationButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 164px;
  height: 48px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  background-color: #e6e6e6;
`
const StyledCancelButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 164px;
  height: 48px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  background-color: #ffbc00;
`

export default KBPayLiveCancelModal
